import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M2 19.778V4.222A2.22 2.22 0 0 1 4.222 2h12.414c.589 0 1.154.234 1.57.651l3.143 3.142c.417.417.65.982.651 1.571v12.414A2.22 2.22 0 0 1 19.778 22H4.222A2.22 2.22 0 0 1 2 19.778Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M8.852 7.556h6.296c.148 0 .289-.07.393-.196a.74.74 0 0 0 .163-.471V2.667a.74.74 0 0 0-.163-.472.51.51 0 0 0-.393-.195H8.852a.51.51 0 0 0-.393.195.74.74 0 0 0-.163.472v4.222a.74.74 0 0 0 .163.471.51.51 0 0 0 .393.196Zm-2.408 7.333V22h11.112v-7.111a.74.74 0 0 0-.163-.471.51.51 0 0 0-.393-.196H7a.51.51 0 0 0-.393.196.74.74 0 0 0-.163.47Z"
    }, null, -1)
  ]))]))
}
export default { render: render }